import React from 'react'
import Layout from '../layout/Layout'
import KvhSlider from '../components/KvhSlider'
import About from './About'
import DisplayProduct from '../components/DisplayProduct'
import ContactUs from '../components/ContactUs'
import Inquiry from '../components/Inquiry'
import Testimonial from '../components/Testimonial'
import WhatsappButton from '../components/WhatsappButton'

export default function LandingPage() {
    return (
        <Layout>


            <KvhSlider />
            <About />
            <Inquiry />
            <DisplayProduct />
            <Testimonial />
            <ContactUs />
            <WhatsappButton />
        </Layout>
    )
}
